export enum LocationType {
  Apartment = 1,
  House = 2,
  Office = 3,
  Hotel = 4,
  Other = 5,
}

export interface CustomerAddress {
  id: string;
  streetLine1: string;
  streetLine2: string | null;
  city: string;
  postalCode: string;
  countryCode: string;
  country: string;
  phoneNumber: string;
  defaultShippingAddress: boolean;
  locationType: LocationType | null;
  entrance: string | null;
  floor: string | null;
  fullName: string | null;
  instructions: string | null;
  latitude: number | null;
  longitude: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface AuthCustomer {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  phoneCountryCode: string;
  imageUrl: string | null;
  dateOfBirth: string | null;
  addresses: CustomerAddress[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateAddressInput {
  streetLine1: string;
  streetLine2?: string;
  city: string;
  postalCode: string;
  countryCode: string;
  phoneNumber?: string;
  locationType?: LocationType;
  entrance?: string;
  floor?: string;
  instructions?: string;
  defaultShippingAddress: boolean;
}

export interface AuthResponse {
  token: string;
  tokenHeaderKey: string;
  authHeaderValue: string;
  userId: string;
  identifier: string;
  customer: AuthCustomer;
}

export interface AuthResponseV2 {
  token: string | null;
  tokenHeaderKey: string | null;
  authHeaderValue: string | null;
  userId: string | null;
  identifier: string | null;
  customer: AuthCustomer | null;
  phoneVerifiedToken: string | null;
}

export interface CompleteProfileInput {
  phoneVerifiedToken: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
}
